import { AnyAction, Middleware } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { I18nHelper } from "@/common/helpers/i18n";
import { AppRootState } from "@/store";

import { GetTypedPayload } from "../ts";
import { _profileFetched, _profileUpdated, profileUpdated } from "./slice";

export const profileMiddleware: Middleware<any, AppRootState, ThunkDispatch<any, any, AnyAction>> =
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    // when profile fetched/updated ensure user i18n settings are stored locally
    if (
      _profileFetched.match(action) ||
      _profileUpdated.match(action) ||
      profileUpdated.match(action)
    ) {
      const _profileFetchedPayload = GetTypedPayload(action, _profileFetched);
      const _profileUpdatedPayload = GetTypedPayload(action, _profileUpdated);
      const profileUpdatedPayload = GetTypedPayload(action, profileUpdated);
      const profile = _profileFetchedPayload || _profileUpdatedPayload || profileUpdatedPayload;

      I18nHelper.saveUserI18nSettingsLocally({
        cultureName: profile?.settings?.culture?.name,
        tzId: profile?.settings?.tzId,
      });
    }

    return next(action);
  };
